import { render, staticRenderFns } from "./PersonalityIntroSection.vue?vue&type=template&id=3f65266b"
import script from "./PersonalityIntroSection.vue?vue&type=script&lang=ts"
export * from "./PersonalityIntroSection.vue?vue&type=script&lang=ts"
import style0 from "./PersonalityIntroSection.vue?vue&type=style&index=0&id=3f65266b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports